/* eslint-disable */
import { Module, MutationTree, GetterTree } from "vuex";
import { ActionTree } from "vuex";
import { RequestStore, RequestData } from "../types/RequestStore";
import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import Parser from "@/models/Parser";
import Vue from "vue";

export const state: RequestStore = {
  status: {},
};

export const getters: GetterTree<RequestStore, unknown> = {
  status(state): { [key: string]: RequestData } {
    return state.status;
  },

  registered: (state) => (key: string) => {
    return state.status[key] !== undefined;
  },
};

export const mutations: MutationTree<RequestStore> = {
  register(state, payload: string) {
    if (state.status[payload]) {
      return;
    }

    Vue.set(state.status, payload, {
      loading: false,
      statusCode: 0,
      errors: null,
    });
  },

  clear(state, payload: string) {
    Vue.set(state.status, payload, {
      loading: false,
      statusCode: 0,
      errors: null,
    });
  },

  setError(
    state,
    payload: {
      tag: string;
      errors: any;
    }
  ) {
    Vue.set(state.status[payload.tag], "errors", payload.errors);
  },

  setResponseData(
    state,
    {
      tag,
      response,
      isError,
    }: {
      tag: string;
      response: AxiosResponse<any>;
      isError: boolean;
    }
  ) {
    state.status[tag].statusCode = response?.status || -1;
    if (!isError) {
      Vue.set(state.status[tag], "meta", response.data.meta);
      Vue.set(state.status[tag], "links", response.data.links);
      return;
    }

    if (response.data && response.data.errors) {
      Vue.set(state.status[tag], "errors", response.data);
    } else {
      Vue.set(state.status[tag], "errors", {
        message: response?.statusText || "Unknown Error",
      });
    }
  },

  setLoading(
    state,
    payload: {
      tag: string;
      loading: boolean;
    }
  ) {
    state.status[payload.tag].loading = payload.loading;
  },
};

export const actions: ActionTree<RequestStore, unknown> = {
  register({ commit }, payload: string) {
    commit("register", payload);
  },

  clear({ commit }, payload: string) {
    commit("clear", payload);
  },

  request(
    { commit, getters, dispatch },
    config: AxiosRequestConfig & { tag: string }
  ) {
    const { tag } = config;

    if (getters["registered"](tag) == false) {
      dispatch("register", tag);
    }

    commit("setLoading", { tag, loading: true });
    return axios(config)
      .then(
        (response) => {
          commit("setResponseData", { tag, response, isError: false });
          if (response.data.data) {
            return Parser.parse(response.data);
          } else {
            return response.data;
          }
        },
        (err) => {
          const { response } = err;
          commit("setResponseData", { tag, response, isError: true });
          return Promise.reject(err);
        }
      )
      .finally(() => commit("setLoading", { tag, loading: false }));
  },
};

export const http: Module<RequestStore, unknown> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
